export enum VisitFileStatusEnum {
  None = 0,
  SavedOnServer = 1,
  UploadedToCore = 2,
  UploadedToPodSpace = 3,
  FileHashesSent = 4,
}

export enum VehicleDeliberatelyTypeEnum {
  Card = 1,
  Document = 2,
  CompanyDocument = 3,
}

export enum VisitStatusEnum {
  CREATED = 1,
  SENDED_TO_CORE = 2,
  FAILED_SEND_TO_CORE = 3,
  INCOMPLETE_DOCUMENTATION = 4,
  EXPIRED = 5,
  FAILED_SEND_DOCUMENTATION_TO_CORE = 6,
  PENDING = 7,
}

export enum VisitLocationTypeEnum {
  INSURER_LOCATION = 1,
  REPRESENTATIVE_UNIT_LOCATION = 2,
}

export enum PersonTypeEnum {
  UNKNOWN = 0,
  REAL = 1,
  LEGAL = 2,
  FOREIGN_NATIONAL = 3,
}

export enum PlateTypeEnum {
  Unknown = 0,
  Car = 1,
  Motorcycle = 2,
  FreeZone = 3,
  Temporary = 4,
}

export enum VisitsTabsEnum {
  Visits = 0,
  Drafts = 1,
  Dispatch = 2,
}

export enum DraftVisitStatusEnum {
  Registered = 1,
  AutoAssigned = 2,
  ManualAssigned = 3,
  Cancelled = 4,
  ReferredByAdmin = 5,
  ReferredByExpert = 6,
}

export enum VisitRequestStatus {
  NotAssigned = 1,
  Assigned = 2,
  Done = 3,
  CancelledByUser = 4,
  CancelledByExpert = 5,
}

export enum AssignedVisitRequestStatus {
  Registered = 1,
  Accepted = 2,
  Rejected = 3,
  CancelledByExpert = 4,
  CancelledByUser = 5,
}
